import { useMemo } from 'react';

import type { ApiUserProfileWorkHistoryJob } from '#/modules/userProfile/api/types/ApiUserProfileWorkHistoryJob';

export function useUserProfileWorkHistoryJobItems(
  workHistoryJobs: ApiUserProfileWorkHistoryJob[],
) {
  return useMemo(() => {
    const workHistoryByPositionType =
      Object.groupBy(
        workHistoryJobs,
        (workHistoryItem) => workHistoryItem.positionType,
      ) || {};

    return {
      workHistoryByPositionType,
      meta: {
        hasJobs: Boolean(workHistoryByPositionType.JOB),
        hasInternships: Boolean(workHistoryByPositionType.INTERNSHIP),
        hasVolops: Boolean(workHistoryByPositionType.VOLOP),
      },
    };
  }, [workHistoryJobs]);
}
